import { Component, Inject } from "@angular/core";
import { ListBase } from "../../settings/shared/list.base";
import { ApplicationSettings } from "../../core/coresettings";

import { ServiceConfig } from "../../core/core.constants";
import { CrewPermissionsService } from "../../core/crew-permissions.service";

@Component({
    selector: "crew-persons",
    template: require('./persons.component.html')
})
export class PersonsComponent extends ListBase<Nema.Crew.Model.Person>  {

    constructor(
        @Inject("persons") public persons: Nema.Crew.Model.Person[],
        @Inject("$state") private $state: ng.ui.IStateService,
        crewPermissionsService: CrewPermissionsService) {

        super(persons, crewPermissionsService);

        this.applicationSettings = ApplicationSettings.instance;
    }

    public webApiUrl: string = ServiceConfig.webApiUrl;

    public newEntityState = "app.resources.persons.new";

    public editEntityState = "app.resources.persons.detail";

    public entityName = "Person";

    public entityNames = "Persons";

    public navigateToPerson(person: Nema.Crew.Model.Person) {
        this.$state.go("app.resources.persons.detail", { id: person.Id });
    }

    public applicationSettings: ApplicationSettings;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/persons.component.ts